import { Model } from '@vuex-orm/core';

export class Status extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'statuses';

  static primaryKey = 'code';

  static fields() {
    return {
      code: this.attr(null),
      name: this.attr(null),
      color: this.attr(null),
    };
  }
}

export default Status;
